export class NewPixiSceneEvents
{
    static PLAYERS_UPDATED: string = 'NewPixiSceneEvents.PLAYERS_UPDATED';
}
